import styles from './style.css'
import {rupiah} from 'utils/formatter'

class CustomerHighlight extends React.Component {
  render () {
    let {customerDetail} = this.props

    return (customerDetail &&
      <div className='customer-info-box'>
        <div className={'header ' + styles['header-name']}>
          Customer Highlights
        </div>
        <div className='info-profile'>
          <table>
            <tbody className={styles['no-hover']}>
              <tr>
                <td className='text-left col-md-6'>
                  Number of Transaction
                </td>
                <td className='text-left col-md-6'>
                  {customerDetail.orders}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Customer Since
                </td>
                <td className='text-left col-md-6'>
                  {customerDetail.member_since}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Last Visit
                </td>
                <td className='text-left col-md-6'>
                  {customerDetail.last_visit}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  This Month
                </td>
                <td className='text-left col-md-6'>
                  {rupiah(customerDetail.this_month_total)}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  This Year
                </td>
                <td className='text-left col-md-6'>
                  {rupiah(customerDetail.this_year_total)}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Lifetime Spend
                </td>
                <td className='text-left col-md-6'>
                  {rupiah(customerDetail.lifetime_total)}
                </td>
              </tr>
              <tr>
                <td className='text-left col-md-6'>
                  Average Spend
                </td>
                <td className='text-left col-md-6'>
                  {rupiah(customerDetail.average_amount)}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    )
  }
}

CustomerHighlight.propTypes = {
  customerDetail: React.PropTypes.object
}

export default CustomerHighlight



// WEBPACK FOOTER //
// ./app/pages/Customers/CustomerList/ListLoyalty/CustomerDetail/CustomerHighlight.js